var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-fluid"},[_c('div',{staticClass:"p-col-12 p-lg-12"},[_c('div',{staticClass:"card card-w-title"},[_c('div',{staticClass:"manager-title-custom-1"},[_vm._v("Đánh Giá Mối Nguy")]),_c('formEdit',{key:_vm.componentKey,attrs:{"company_id":_vm.company_id,"model":_vm.models},on:{"back":_vm.backToList,"save":_vm.saveData}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }